

export const selectTypes = {
    addSelectOptions: '[Selects] Add Select Options',
    cleanSelectOptions: '[Selects] Clean Options'
}